import React from 'react'
import logopattern from '../../assets/Ball-pattern.png';
import './LogoBall.scss';

export default function LogoBall() {
  return (
    <React.Fragment>
      <div className="logo-ball">
        <img className="pattern" src={logopattern} alt="" />
        <img className="repeat" src={logopattern} alt="" />
        <img className="again" src={logopattern} alt="" />
      </div>
    </React.Fragment>
  )
}
